import type { TranslationKey } from "./i18n/store.js";

/**
 * A rough, length-based estimate of how long a generation takes, shown in the
 * "generation started" popup. Returns a translation KEY (not a string) so the
 * localized estimate is looked up at render time. Deliberately a range, not a
 * promise: real time depends on the provider and rate tier. Rendering images is
 * the slow part, so a text-only draft is markedly faster.
 */
export type GenerationLength = "short" | "medium" | "long";

const ESTIMATE_KEYS: Record<
  GenerationLength,
  { withImages: TranslationKey; textOnly: TranslationKey }
> = {
  short: { withImages: "estimate.shortImages", textOnly: "estimate.shortText" },
  medium: { withImages: "estimate.mediumImages", textOnly: "estimate.mediumText" },
  long: { withImages: "estimate.longImages", textOnly: "estimate.longText" }
};

/** The translation key for the estimate. Defaults to the medium band. */
export function estimateGenerationTimeKey(
  length: GenerationLength | undefined,
  generateImages: boolean
): TranslationKey {
  const band = ESTIMATE_KEYS[length ?? "medium"];
  return generateImages ? band.withImages : band.textOnly;
}
